module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu-expanded"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "mode": "vertical",
      "default-active": _vm.$route.name,
      "unique-opened": "",
      "router": ""
    }
  }, [_vm._l((_vm.menues), function(menu) {
    return [(menu.isLeaf === false) ? _c('el-menu-item', {
      attrs: {
        "index": menu.routeName
      },
      on: {
        "click": function($event) {
          _vm.navigate(menu.routeName)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "width": "20px",
        "margin": "auto"
      },
      attrs: {
        "name": menu.icon,
        "fill": "#6b6b6b"
      }
    }), _vm._v("\n        " + _vm._s(menu.name) + "\n      ")], 1) : _c('el-submenu', {
      attrs: {
        "index": menu.routeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('icon', {
      staticStyle: {
        "width": "20px",
        "margin": "auto"
      },
      attrs: {
        "name": menu.icon,
        "fill": "#6b6b6b"
      }
    }), _vm._v(" " + _vm._s(menu.name) + "\n        ")], 1), _vm._v(" "), _vm._l((menu.subMenu), function(sub) {
      return [_c('el-menu-item', {
        key: sub.name,
        attrs: {
          "index": sub.routeName
        },
        on: {
          "click": function($event) {
            _vm.navigate(sub.routeName)
          }
        }
      }, [_c('icon', {
        staticStyle: {
          "width": "20px",
          "margin": "auto"
        },
        attrs: {
          "name": sub.icon,
          "fill": "#6b6b6b"
        }
      }), _vm._v("\n            " + _vm._s(sub.name) + "\n          ")], 1)]
    })], 2)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0715e12"}!./src/components/sidebar/sidebar.html
// module id = 822
// module chunks = 1